module.exports = __webpack_public_path__ + "img/konstanta.89a8f6f3.png";